import { Component, OnInit, EventEmitter, ViewChild, Output } from '@angular/core';
import { ConfigOption, ConfigStorage, ConfigResult } from './upload-excel-config.model';
import { ModalControl } from '../../../modal-control/modal-control.component';
import { SettingService } from '../../../../services/setting/setting.service';
import { TranslateService } from '../../../../services/translate/translate.service';

@Component({
  selector: 'sd-upload-excel-config',
  templateUrl: './upload-excel-config.component.html',
  styleUrls: [
    '../../../../assets/css/button.scss',
    '../../../../assets/css/scrollbar.scss',
    '../../../../assets/css/box.scss',
    '../../../../assets/css/input.scss',
    './upload-excel-config.component.css'
  ]
})
export class UploadExcelConfigComponent implements OnInit {
  @ViewChild('modal') modal: ModalControl;
  // tslint:disable-next-line: no-output-native
  @Output() change = new EventEmitter<ConfigResult>();

  option: ConfigOption;
  storage: ConfigStorage;

  constructor(
    private settingService: SettingService,
    private translateService: TranslateService) { }

  ngOnInit() {
  }

  async setOption(option: ConfigOption) {
    this.option = option;
    await this.init();
    this.emitOnChange();
  }

  private async init() {
    if (this.option.key && this.settingService.get(this.option.key)) {
      try {
        this.storage = await this.settingService.get(this.option.key);
        if (!this.storage) {
          // Xóa setting
          this.settingService.remove(this.option.key);
          // Lấy setting mặc định
          this.initDefault();
          return;
        }
        // Loại bỏ những column đã bị xóa khỏi originColumns
        this.storage.columns = this.storage.columns.filter(column => this.option.columns.some(e => e.field === column.originColumn.field));

        // Thêm những column mới vào storage nếu có
        this.option.columns.forEach(column => {
          if (!this.storage.columns.some(e => e.originColumn.field === column.field)) {
            this.storage.columns.push({
              originColumn: {
                field: column.field,
                title: column.title,
                width: column.width,
                required: column.required
              },
              hidden: false
            });
          }
        });

        // Cập nhật originColumn
        this.storage.columns.forEach(column => {
          const originColumn = this.option.columns.find(e => e.field === column.originColumn.field);
          if (originColumn) {
            Object.assign(column.originColumn, {
              title: originColumn.title,
              width: originColumn.width
            });
          }
        });
      } catch (err) {
        // Xóa setting
        this.settingService.remove(this.option.key);
        // Lấy setting mặc định
        this.initDefault();
      }
    } else {
      this.initDefault(); // Lấy setting mặc định
    }
  }

  private initDefault() {
    this.storage = {};
    this.storage.formatDate = '';
    this.storage.columns = [];
    this.option.columns.forEach(column => {
      this.storage.columns.push({
        originColumn: {
          field: column.field,
          title: column.title,
          width: column.width,
          required: column.required
        },
        hidden: false
      });
    });
  }

  open() {
    this.modal.open();
  }

  save() {
    this.settingService.set(this.option.key, this.storage);
    this.emitOnChange();
    this.modal.close();
  }

  reset() {
    this.settingService.remove(this.option.key);
    this.initDefault();
    // this.reload();
    this.emitOnChange();
    this.modal.close();
  }

  moveColumnUp(index: number) {
    const temp = this.storage.columns[index];
    this.storage.columns[index] = this.storage.columns[index - 1];
    this.storage.columns[index - 1] = temp;
  }

  moveColumnDown(index: number) {
    const temp = this.storage.columns[index];
    this.storage.columns[index] = this.storage.columns[index + 1];
    this.storage.columns[index + 1] = temp;
  }

  emitOnChange() {
    const formatDate = this.storage.formatDate || '';
    const columns = this.option.columns.filter(column => {
      // Hidden column theo config
      // Lấy các thuộc tính Title, Width từ config
      const columnConfig = this.storage.columns.find(e => e.originColumn.field === column.field);
      if (columnConfig) {
        column.title = columnConfig.title || this.translateService.translate(columnConfig.originColumn.title);
        column.width = columnConfig.width || columnConfig.originColumn.width;
        return !columnConfig.hidden;
      } else {
        return true;
      }
    }).sort((current, next) => {
      // Sắp xếp theo config
      const currentIndex = this.storage.columns.findIndex(e => e.originColumn.field === current.field);
      const nextIndex = this.storage.columns.findIndex(e => e.originColumn.field === next.field);
      return currentIndex - nextIndex;
    });
    const result: ConfigResult = {
      formatDate: '',
      // pageSize: pageSize,
      columns
    };
    this.change.emit(result);
  }
}
